import { render, staticRenderFns } from "./UploadTemplate.vue?vue&type=template&id=fa445718&scoped=true"
import script from "./UploadTemplate.vue?vue&type=script&lang=js"
export * from "./UploadTemplate.vue?vue&type=script&lang=js"
import style0 from "./UploadTemplate.vue?vue&type=style&index=0&id=fa445718&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa445718",
  null
  
)

export default component.exports